import * as ApiHelper from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import type { PreviewData } from "../types/models";
import { transformPreviewItem } from "../utils/transformers";
import type { PreviewDataDTO } from "../types/dtos";

export type EndpointResponse = PreviewDataDTO | string;
export interface Result {
  data: PreviewData;
  error?: string;
}

const apiUrl = resolveApiUrl("/my-account/quotes/quotation-split-upload");

export const sendQuoteForValidation = async (file: File, signal?: AbortSignal): Promise<Result> => {
  const data = new FormData();
  data.append("file", file);

  const params: RequestInit = {
    body: data,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
    signal,
  };

  const res = await fetch(apiUrl, params);
  const json: EndpointResponse = await res.json();

  if (json !== null && typeof json === "object") {
    return {
      data: {
        invalidQuotes: json.invalidQuotes,
        results: json.results.map(transformPreviewItem),
      },
    };
  } else {
    return {
      error: json,
      data: {} as PreviewData,
    };
  }
};
